import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor( ) { }

  saveUser(storage, data) {
    storage.setItem('user', data);
    // storage.setItem('currentUser', data);
  }

  saveToken(storage, data) {
    storage.setItem('token', data);
  }

  setLocalObject(key: string, value: any) {
    localStorage.setItem(key, value);
    // localStorage.setItem(key, value);
  }

  setSessionObject(key: string, value: any) {
    sessionStorage.setItem(key, value);
    // sessionStorage.setItem(key, value);
  }

  getLocalObject(key: string) {
    return localStorage.getItem(key) ?
      JSON.parse(localStorage.getItem(key))
      : null;
  }

  getSessionObject(key: string) {
    return sessionStorage.getItem(key) ?
      JSON.parse(sessionStorage.getItem(key))
      : null;
  }

  removeLocalObject(key: string) {
    localStorage.removeItem(key);
  }

  removeSessionObject(key: string) {
    sessionStorage.removeItem(key);
  }
}